import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';

export function AppShell() {
  return (
    <div className="flex h-full bg-hs-bg">
      <Sidebar />
      <main className="flex-1 overflow-auto px-8 py-8">
        <div className="mx-auto max-w-[960px]">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
